import styled from 'styled-components'

export const Wrapper = styled.div``

export const Heading = styled.div`
  padding: 20px 20px 0 20px;
`
